import {Typography, Zoom} from "@material-ui/core";
import React from "react";
import i18n from "../../../../i18nextInitiator";
/**
 * translate function.
 * @type {TFunction}
 */
const t = i18n.getFixedT('fa', 'general');
/**
 * this component is used inside ProgressTruck component.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const TrackerMessage = props => props.progressEnded
    ? <Zoom in>
        <Typography color={"primary"}> {t("invoice.special-order")} </Typography>
    </Zoom>
    : <Typography color={"primary"}> {t("invoice.looking-for-driver")} </Typography>
export default TrackerMessage